/* @refresh reload */
import { render } from "solid-js/web";
import { Router, Route } from "@solidjs/router";
import AppShell from "./components/AppShell";
import Home from "./pages/Home";
import Search from "./pages/Search";
import Likes from "./pages/Likes";
import Profile from "./pages/Profile";
import SignIn from "./pages/SignIn";
import SignOut from "./pages/SignOut";
import SnipView from "./pages/SnipView";
import SnipEditor from "./pages/SnipEditor";
import Help from "./pages/Help";
import "highlight.js/styles/atom-one-dark.css";
import "./index.css";

const root = document.getElementById("root");

if (!root) {
  throw new Error("Root element #root not found");
}

render(
  () => (
    <Router root={AppShell}>
      <Route path="/" component={Home} />
      <Route path="/search" component={Search} />
      <Route path="/likes" component={Likes} />
      <Route path="/profile" component={Profile} />
      <Route path="/sign-in" component={SignIn} />
      <Route path="/sign-out" component={SignOut} />
      <Route path="/new" component={SnipEditor} />
      <Route path="/snip/:id" component={SnipView} />
      <Route path="/snip/:id/edit" component={SnipEditor} />
      <Route path="/help" component={Help} />
    </Router>
  ),
  root
);
